import React, { useEffect, useState } from "react";
import "./CommissionRateHistoryTable.scss";
import DataTable, { IDataTableColumn } from "react-data-table-component";
import { Modal, Button } from "reactstrap";
import I18n from "../../../../../i18n/utils";
import assess from "../../../../assets/icons/assess.svg";
import "./CommissionRateHistoryTable.scss";
import {
  formatReverseDateUtc,
  formatShortDate,
} from "../../../../utils/DateUtil";
import ICommissionRateHistory from "../../../../interfaces/ICommissionRateHistory";
import DeliveryPartnerCommissionRate from "../../../../interfaces/DeliveryPartnerCommissionRate";
import XSLX from "xlsx";
import CommissionRateHistoryForm from "../../CommissionRateHistoryForm/CommissionRateHistoryForm";
import { useDispatch, useSelector } from "react-redux";
import {
  deliveryPartnerBusinessUnitUpdateSelector,
  fetchDeliveryPartners,
} from "../../../../redux/features/deliveryPartnerSlice";

const CommissionRateHistoryTable: React.FC<ICommissionRateHistory> = ({
  deliveryPartnerId,
  deliveryPartnerName,
  deliveryPartnerCommissionRateHistoryList,
  deliveryPartnerForm,
  updateDeliveryPartners,
}: ICommissionRateHistory): JSX.Element => {
  const [displayUpdateModal, setDisplayUpdateModal] = useState(false);
  const [selectedCell, setSelectedCell] = useState({});

  useEffect(() => {}, [displayUpdateModal, selectedCell]);

  const dispatch = useDispatch();
  const showUpdateModal = (cell: React.SetStateAction<{}>) => {
    setSelectedCell(cell);
    setDisplayUpdateModal(true);
  };

  const closeUpdateModal = () => {
    setDisplayUpdateModal(false);
    resetFormModal();
    dispatch(fetchDeliveryPartners());
  };

  const resetFormModal = () => {
    return { loading: false, error: false, message: false };
  };

  const exportCommissionHistory = () => {
    const ws = XSLX.utils.json_to_sheet(
      deliveryPartnerCommissionRateHistoryList.map((bu) => {
        return {
          "Vendor Name": bu.deliveryPartnerName,
          "Commission Rate (%)": bu.defaultCommissionRate,
          "Commission Fee ($)": bu.defaultCommissionFee,
          "Calc Type": bu.commissionCalcType,
          "Start Date": formatReverseDateUtc(bu.defaultCommissionRateStartDate),
          "End Date": bu.defaultCommissionRateEndDate
            ? formatReverseDateUtc(bu.defaultCommissionRateEndDate)
            : null,
        };
      })
    );

    const wb = XSLX.utils.book_new();
    XSLX.utils.book_append_sheet(wb, ws, "Current");
    XSLX.writeFile(wb, `${deliveryPartnerName}-Commissions.xlsx`);
  };

  const columns: IDataTableColumn<DeliveryPartnerCommissionRate>[] = [
    {
      cell: (cell: React.SetStateAction<{}>) => (
        <img
          id="logoTooltip"
          src={assess}
          width="20"
          height="20"
          className="edit-icon"
          alt="CFA Logo"
          onClick={() => showUpdateModal(cell)}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: I18n.t("APP_DELIVERY_PARTNERS_UPDATE_FORM_VENDOR_NAME_LABEL"),
      selector: "deliveryPartnerName",
      cell: (cell) => (
        <h3 className="custom-cell">{cell.deliveryPartnerName}</h3>
      ),
      sortable: true,
    },
    {
      name: I18n.t("APP_DELIVERY_PARTNERS_UPDATE_FORM_COMMISSION_RATE_LABEL"),
      selector: "defaultCommissionRate",
      cell: (cell) => (
        <h3 className="custom-cell">{cell.defaultCommissionRate}%</h3>
      ),
      sortable: true,
    },
    {
      name: I18n.t("APP_DELIVERY_PARTNERS_UPDATE_FORM_COMMISSION_FEE_LABEL"),
      selector: "defaultCommissionFee",
      cell: (cell) => (
        <h3 className="custom-cell">
          {cell.defaultCommissionFee
            ? "$" + cell.defaultCommissionFee
            : "$0.00"}
        </h3>
      ),
      sortable: true,
    },
    {
      name: I18n.t(
        "APP_DELIVERY_PARTNERS_UPDATE_FORM_COMMISSION_CALC_TYPE_LABEL"
      ),
      selector: "commissionCalcType",
      cell: (cell) => (
        <h3 className="custom-cell">{cell.commissionCalcType || "ROUND"}</h3>
      ),
      sortable: true,
    },
    {
      name: I18n.t(
        "APP_DELIVERY_PARTNERS_UPDATE_FORM_COMMISSION_FEE_START_DATE_LABEL"
      ),
      selector: "defaultCommissionRateStartDate",
      cell: (cell) => (
        <h3 className="custom-cell">
          {formatShortDate(cell.defaultCommissionRateStartDate)}
        </h3>
      ),
    },
    {
      name: I18n.t(
        "APP_DELIVERY_PARTNERS_UPDATE_FORM_COMMISSION_FEE_END_DATE_LABEL"
      ),
      selector: "defaultCommissionRateEndDate",
      cell: (cell) => (
        <h3 className="custom-cell">
          {cell.defaultCommissionRateEndDate != null
            ? formatShortDate(cell.defaultCommissionRateEndDate)
            : I18n.t("APP_BUSINESS_UNIT_OVERRIDES_UPDATE_NOT_APPLICABLE")}
        </h3>
      ),
    },
  ];

  const actions = (
    <>
      <Button className="add-override-modal-button" onClick={showUpdateModal}>
        {I18n.t("APP_COMMISSION_HISTORY_ADD_FORM_TITLE")}
      </Button>
      <Button
        className="add-override-modal-button"
        onClick={exportCommissionHistory}
      >
        {I18n.t("APP_COMMISSION_RATE_HISTORY_EXPORT")}
      </Button>
    </>
  );

  // TODO loading spinner implementation
  let loading = false;

  return (
    <div className="CommissionRateHistoryTable">
      {
        <DataTable
          title={I18n.t("APP_BUSINESS_UNIT_COMMISSION_RATE_HISTORY_TITLE")}
          actions={actions}
          keyField="id"
          defaultSortField="deliveryPartnerId"
          defaultSortAsc={true}
          columns={columns}
          data={deliveryPartnerCommissionRateHistoryList}
          pagination
          persistTableHead
          responsive
          dense
          striped
        />
      }

      <Modal
        isOpen={displayUpdateModal}
        className="modal-dialog"
        modalClassName="add-partner-modal"
      >
        <CommissionRateHistoryForm
          deliveryPartnerName={deliveryPartnerName}
          deliveryPartnerId={deliveryPartnerId}
          //@ts-ignore
          selectedCommission={selectedCell}
          commissions={deliveryPartnerCommissionRateHistoryList}
          close={closeUpdateModal}
          deliveryPartnerForm={deliveryPartnerForm}
          updateDeliveryPartners={updateDeliveryPartners}
        />
      </Modal>
    </div>
  );
};

export default CommissionRateHistoryTable;
